<template>
<main id="maincontent">
    <div v-if="active" id="login" class="card">
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <div class="row mx-0">
            <InfoMessage v-for="(message, index) in messages" :title="message.messageSubjectLine" :body="message.messageContent" :index="index"></InfoMessage>
        </div>
        <Error ref="error" />
        <div class="card-body">
            <PageHeader :title="screenData.text.cardTitle" variant="small"/>
            <p v-if="msgFound" class="text-center mt-3" role="alert" aria-live="assertive"><fa-icon :icon="['fas','check-circle']" class="mr-1" />{{successMsg}}</p>
            <form class="mt-4" action="">
                <Username ref="username" :username-label="screenData.text" :forgot-user-action="screenData.links.forgotUserPath" :forgot-user-label="screenData.links.forgotUserLabel" :display-forgot-user-link=true @forgot-user-id="displayForgotUser" />
                <Password ref="password" :label="screenData.text.password" />
                <div class="d-flex justify-content-center"><a class="mt-1 mb-2" :action="screenData.links.forgotPassPath" href="" @click="displayForgotPass">{{screenData.links.forgotPassLabel}}</a></div>
                <ActionList :actions="screenData.actions" @do-login="doLogin" @do-new-user="doNewUser" />
            </form>
            <p class="mt-5 fine-print">{{screenData.text.enhancedSecurityLabel}}<br>{{screenData.text.enhancedSecurityText}}</p>
        </div>
    </div>
</main>
</template>

<script>
    import { nextTick } from 'vue'
    import InfoMessage from '../entities/InfoMessage.vue';
    import Error from '../entities/Error.vue';
    import Username from '../entities/Username.vue';
    import Password from '../entities/Password.vue';
    import Action from '../entities/Action.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';
    import {stripHtml} from "../../../utility/miscellaneous";

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "Login",

        components: {
            InfoMessage,
            Error,
            Username,
            Password,
            Action,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        data: function() {
            return {
                active: false,
                messages: [],
                successMsg: "",
                msgFound: false
            }
        },

        props: {
            screenData: Object,
            profileCallerId: String
        },

        methods: {
            stripHtml,
            show: function(data) {
                this.active = true;
                nextTick(function(){
                    this.clear();
                    if(data !== undefined){
                        this.msgFound = data.success;
                        this.successMsg = data.passwordSetMsg;
                        this.prefilleddUsername();
                    if(data.error){
                        var err = data.error;
                        this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType);
                        }  
                    }

                    if(!data || !data._IS_INITIAL) {
                        this.$emitter.emit('reprofileThreatMatrics');
                    }
                }.bind(this));
            },

            hide: function() {                
                this.active = false;
            },

            clear: function() {
                this.$refs["username"].clear();
                this.$refs["password"].clear()
            },

            setEventType: function(eventTypeValue){
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set('userEventType', eventTypeValue);
                window.history.pushState({}, '', currentUrl);   
            },

            displayForgotPass: function(e) {
                e.preventDefault();                
                this.$refs["error"].clear();
                if (this.$refs["username"].isUsernameValid()) {
                    var variableData = {
                        username: this.$refs["username"].getValue(),
                        flow: this.screenData.text.forgotPassFlow,
                        init: true,
                        validateAPI: '/BFWeb/cwapi/' + this.getClient() + '/authn/recovery/password-init',
                        nextStep: this.screenData.text.fogotPassNextStep
                    };
                    //this.setEventType('password_reset');
                    this.$root.username = this.$refs["username"].getValue();
                    this.$emitter.emit('navigate', { componentName: e.target.attributes.action.value, routeData: variableData});
                }
                else {
                    this.$refs["error"].display(this.screenData.error.username.code, this.screenData.error.username.message, this.screenData.error.type);
                }
            },

            displayForgotUser: function() {
                var data = {
                    flow: this.screenData.text.forgotUserFlow,
                    init: true,
                    validateAPI:  '/BFWeb/cwapi/' + this.getClient() + '/authn/recovery/userid-init',
                    nextStep: this.screenData.text.forgotUserNextStep
                };
                //this.setEventType('Forgot_Username');  
                this.$emitter.emit('navigate', { componentName: 'challengePII', routeData: data});
            },

            navigate: function(action, data) {
                this.$emitter.emit('navigate', { componentName: action, routeData: data});
            },

            doLogin: function() {
                this.$emitter.emit('start-loading','do-login');

                this.$refs["error"].clear();
                    var API = "/BFWeb/cwapi/" + this.getClient() + "/authn";
                    var data = {
                        "username": this.$refs["username"].getValue(),
                        "password": this.$refs["password"].getValue(),
                        "devicePrint": encode_deviceprint(),
                        "profileCallerId": this.profileCallerId
                    };

                    this.$axios.post(API, data).then(function(response) {
                        if (response.data.success && response.data.data.status === "MFA_REQUIRED") {
                            var data = {
                                flow: this.screenData.text.loginFlow,
                                methods: response.data.data._embedded.factors,
                                stateToken: response.data.data.stateToken,
                                cancelUrl: response.data.data._links.cancel.href
                            };
                            this.$root.username = this.$refs["username"].getValue();
                            this.$emitter.emit('stop-loading','do-login');
                            this.navigate("mfaSelect", data);
                        }
                        else if (response.data.success && response.data.data.status === "PII_CHALLENGE") {
                            var data = {
                                flow: this.screenData.text.loginFlow,
                                stateToken: response.data.data.stateToken,
                                tinType: response.data.data._embedded.factors[0].policy.complexity.tinType,
                                accountRequired: response.data.data._embedded.factors[0].policy.complexity.accountRequired,
                                dateOfBirthRequired: response.data.data._embedded.factors[0].policy.complexity.dateOfBirthRequired,
                                init: false,
                                validateAPI: response.data.data._embedded.factors[0]._links.validatePii.href,
                                nextStep: this.screenData.text.loginNextStep,
                                skipCollection: false,
                                skipMfaEnrollment: response.data.data._embedded.factors[0].policy.complexity.skipMfaEnrollment
                            };
                            this.$root.username = this.$refs["username"].getValue();
                            this.navigate('challengePII', data);
                            this.$emitter.emit('stop-loading','do-login');
                        }
                        else if (response.data.success && response.data.data.status === "SUCCESS") {
                            this.$root.username = this.$refs["username"].getValue();
                            this.start(response.data.data._links);
                        }
                        else if (response.data.success && response.data.data.status === "LOCKED_OUT") {                            
                            var data = {
                                flow: this.screenData.text.loginFlow,
                                errorCode: "8004",
                                isSuspended: true
                            };
                            this.$root.username = this.$refs["username"].getValue();
                            this.$emitter.emit('stop-loading','do-login');
                            this.$emitter.emit('navigate', { componentName: 'accountHold', routeData: data});
                        }
                        else if(response.headers["content-type"] === 'text/html; charset=utf-8' || response.headers["content-type"] === 'text/html'){
                            const data = {
                                    flow: this.screenData.text.loginFlow,
                                    errorCode: '8000',
                                    isSuspended: true
                                };
                                this.$root.$emit('stop-loading','do-login');
                                this.$parent.navigate('accountHold', data);
                        }
                    }.bind(this)).catch(function(error) {
                        if (typeof error.response.data == 'string' || error.response.data.messages.length > 0) {
                            this.$emitter.emit('reprofileThreatMatrics');
                            var err = typeof error.response.data == 'string' ? {
                                errorCode: error.response.status,
                                errorMessage: error.message
                            } : error.response.data.messages[0];
                            if (err.errorCode === "8004" || err.errorCode === "8000") {
                                const data = {
                                    flow: this.screenData.text.loginFlow,
                                    errorCode: err.errorCode,
                                    isSuspended: true
                                };
                                this.$emitter.emit('stop-loading','do-login');
                                this.$emitter.emit('navigate', { componentName: 'accountHold', routeData: data});
                            }
                            else {
                                this.$refs["error"].display(err.errorCode, err.errorMessage, err.errorType, err.errorCode === "9999" ? this.screenData.text.invalidCredentialsErrMsg : null);
                            }
                        }
                        this.$refs["username"].clear();
                        this.$emitter.emit('stop-loading','do-login');
                    }.bind(this));
            },

            doNewUser: function() {
                this.$emitter.emit('start-loading','do-new-user');
                var data = {
                    flow: this.screenData.text.newUserFlow,
                    init: true,
                    validateAPI: '/BFWeb/cwapi/' + this.getClient() + '/authn/register-new-user-init',
                    nextStep: this.screenData.text.newUserNextStep,
                    skipCollection: true
                };
                this.$emitter.emit('navigate', { componentName: 'challengePII', routeData: data});
                this.$emitter.emit("stop-loading","do-new-user");
            },

            prefilleddUsername: function(){
                if(this.$root.loginusername){
                 this.$refs["username"].setValue(this.$root.loginusername);
                 delete this.$root.loginusername;
                }
            }
        },

        mounted: function() {
            this.$axios.post('informationalMessageJSON', {}).then(function(response) {
                this.messages = response.data.data.messageList;
            }.bind(this));
        },

        inject: [
            'getClient'
        ]
    }
</script>

<style scoped>    
    button {
        width: 100%;
        box-sizing: border-box;
    }
</style>